import RegisteredUsers from './RegisteredUsers';

const SuperadminUsersRegistry = () => <RegisteredUsers />;

export default SuperadminUsersRegistry;
